import { useLocation, useNavigate } from "react-router";
import Styles from "../User/User.module.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Formik } from "formik";
import { Button, colors } from "@mui/material";
import CustomField from "../../components/shared/CustomTextField";
import {
  deleteSchool,
  deleteSchoolGroup,
  getCategory,
  getOrder,
  getSchool,
  getSchoolGroup,
  updateOrder,
  updateSchool,
} from "../../utils/API/schoolMethods";
import { AgGridReact } from "ag-grid-react";
import { useCallback, useMemo, useState } from "react";
import {
  autoColumns,
  defaultColDef,
  getRowId,
  getUserRowStyle,
  groupColumns,
  orderColumns,
  userColumns,
} from "../../utils/gridHelper";
import GridToolBar from "../../components/GridToolBar";
import { useStore } from "../../hooks/store";
import NewUserForm from "../../components/Form/NewUserForm";
import { getUserBySchool, getUserCredit } from "../../utils/API/userMethods";
import SchoolGroupForm from "../../components/Form/SchoolForm/SchoolGroupForm";
import ReactCalendar from "../../components/ReactCalendar";
import { deleteAuto, getAuto } from "../../utils/API/autoMethods";
import NewAutoForm from "../../components/Form/AutoForm/newAutoForm";

export default function SchoolRedactPage() {
  const store = useStore();
  const { state } = useLocation();
  const nav = useNavigate();
  const handleBack = () => nav(-1);

  /**
   *
   *
   * Group grid
   *
   *
   */
  const [groupData, setGroupData] = useState([]);
  const [groupRowData, setGroupRowData] = useState(null);
  const [groupGridApi, setGroupGridApi] = useState(null);

  const fetchGroupData = () => {
    setGroupRowData(null);
    getSchoolGroup(state.id).then(({ data, status }) =>
      status == 200 ? setGroupData(data) : setGroupData([]),
    );
  };

  const onGroupGridReady = useCallback((e) => {
    // сохраняем АПИ
    setGroupGridApi(e.api);
    fetchGroupData();
  }, []);

  const groupRowClickHandler = (e) => {
    e.data && setGroupRowData(e.data);
  };

  const groupAddOpener = () => {
    store.setForm(<SchoolGroupForm />, fetchGroupData, { school_id: state.id });
  };

  const groupRedactOpener = () => {
    store.setForm(<SchoolGroupForm />, fetchGroupData, {
      ...groupRowData,
      school_id: state.id,
    });
  };

  const handleGroupDelete = async () => {
    const confirm = await window.confirm(
      "Вы уверены что хотите удалить группу? Это действие невозможно отменить",
    );
    confirm &&
      deleteSchoolGroup(groupRowData.id).then(({ data, status }) => {
        if (status === 200) {
          store.setAlert(data, "success");
          fetchGroupData();
          return;
        }

        store.setAlert(data, "error");
      });
  };

  /**
   *
   *
   * Worker grid
   *
   *
   */
  const [workerData, setWorkerData] = useState([]);
  const [workerRowData, setWorkerRowData] = useState(null);
  const [workerGridApi, setWorkerGridApi] = useState(null);

  const fetchWorkerData = () => {
    getUserBySchool(state.id).then(({ data, status }) =>
      status == 200
        ? setWorkerData(data.filter((user) => user.role != 1))
        : setWorkerData([]),
    );
  };
  const onWorkerGridReady = useCallback((e) => {
    // сохраняем АПИ
    setWorkerGridApi(e.api);
    fetchWorkerData();
  }, []);

  const handleAddWorkerOpener = () => {
    getSchool().then(({ data, status }) => {
      store.setForm(<NewUserForm />, fetchWorkerData, {
        schoolList: data.filter((school) => school.id == state.id),
        defaultSelected: data.filter((school) => school.id == state.id)[0].id,
      });
    });
  };

  const navToWorkerRedact = () => {
    const { id } = workerRowData;
    getUserCredit(id).then((result) => {
      getSchool().then((schoolResult) => {
        nav("/user/" + id, {
          state: {
            ...workerRowData,
            ...result.data[0],
            schoolList: schoolResult.data,
          },
        });
      });
    });
  };

  const workerRowClickHandler = (e) => {
    e.data && setWorkerRowData(e.data);
  };

  const rowSelection = useMemo(() => {
    return {
      mode: "singleRow",
      checkboxes: true,
      enableClickSelection: true,
    };
  }, []);
  /**
   *
   *
   * Order data
   *
   *
   */
  const [orderData, setOrderData] = useState([]);
  const [orderRowData, setOrderRowData] = useState(null);
  const [orderGridApi, setOrderGridApi] = useState(null);

  const fetchOrderData = () => {
    getOrder(state.id).then(({ data, status }) =>
      status == 200
        ? setOrderData(data.filter((user) => user.role != 1))
        : setOrderData([]),
    );
  };
  const onOrderGridReady = useCallback((e) => {
    // сохраняем АПИ
    setOrderGridApi(e.api);
    fetchOrderData();
  }, []);

  const handleOrderRedactOpener = () => {
    const { id } = orderRowData;

    nav("/order/" + id, {
      state: { orderData: orderRowData, schoolData: state, groupData },
    });
    // getUserCredit(id).then((result) => {
    //   getSchool().then((schoolResult) => {
    //     nav("/user/" + id, {
    //       state: {
    //         ...workerRowData,
    //         ...result.data[0],
    //         schoolList: schoolResult.data,
    //       },
    //     });
    //   });
    // });
  };

  const orderRowClickHandler = (e) => {
    e.data && setOrderRowData(e.data);
  };

  /**
   *
   *
   * Auto data
   *
   *
   */
  const [autoData, setAutoData] = useState([]);
  const [autoRowData, setAutoRowData] = useState(null);
  const [autoGridApi, setAutoGridApi] = useState(null);

  const fetchAutoData = () => {
    getAuto().then(({ data, status }) =>
      status === 200 ? setAutoData(data) : setAutoData([]),
    );
  };

  const onAutoGridReady = useCallback((e) => {
    // сохраняем АПИ
    setAutoGridApi(e.api);
    fetchAutoData();
  }, []);

  const autoAddOpener = () => {
    getCategory().then(({ data, status }) => {
      if (status === 200) {
        return store.setForm(<NewAutoForm />, fetchAutoData, {
          id: null,
          brend: null,
          model: null,
          year: null,
          license_plate: null,
          is_auto_transmission: null,
          category_id: null,
          status: "active",
          categoryList: data,
          photo: [],
        });
      }

      store.setAlert("Ошибка запроса данных для нового авто", "error");
    });
  };

  const handleAutoRedactOpener = () => {
    getCategory().then(({ data, status }) => {
      if (status === 200) {
        return store.setForm(<NewAutoForm />, fetchAutoData, {
          ...autoRowData,
          categoryList: data,
        });
      }

      store.setAlert("Ошибка запроса данных авто", "error");
    });
  };

  const handleAutoDelete = async () => {
    const confirm = await window.confirm(
      "Вы уверены что хотите удалить учебный автомобиль?",
    );

    confirm &&
      deleteAuto(autoRowData.id).then(({ data, status }) => {
        if (status === 200) {
          store.setAlert(data, "success");
          fetchAutoData();
          return;
        }

        store.setAlert(data, "error");
      });
  };

  const autoRowClickHandler = (e) => {
    e.data && setAutoRowData(e.data);
  };

  /**
   *
   *
   * Universal tools
   *
   *
   */
  const handleDelete = async () => {
    const isConfirmed = await window.confirm(
      "Вы уверены что хотите удалить пользователя? Это действие невозможно отменить",
    );
    isConfirmed && deleteSchool(state.id);
  };

  const handleUpdate = (values) => {
    updateOrder().then(({ data, status }) => {
      if (status === 200) {
        store.setAlert(data, "success");
        return;
      }

      store.setAlert(data, "error");
    });
  };

  return (
    <section className={Styles.user_redact_content}>
      <div className={Styles.user_nav}>
        {/* <ArrowBackIcon onClick={handleBack} /> */}
        <h6>
          Измененние автошколы: <strong>{state.name}</strong>
        </h6>
      </div>
      <div className={Styles.user_field_wrapper}>
        <Formik
          initialValues={{ ...state }}
          onSubmit={(values, { setSubmitting, setTouched }) => {
            setSubmitting(true);
            updateSchool(values, state.id).then(({ data, status }) => {
              if (status === 200) {
                store.setAlert(data, "success");

                setTouched({});
                setSubmitting(false);
                return;
              }

              store.setAlert(data, "error");
            });
            setSubmitting(false);
          }}>
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            handleReset,
            submitForm,

            /* and other goodies */
          }) => (
            <>
              <hr />
              <div className={Styles.user_field_area}>
                <h6>Основная информация</h6>
                <div
                  className={Styles.user_fields}
                  style={{ gridTemplateColumns: "1fr 1fr " }}>
                  <CustomField
                    name="name"
                    label={"Название автошколы"}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.name}
                  />
                  <CustomField
                    name="phone"
                    label={"Номер телефона"}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.phone}
                  />
                  <CustomField
                    name="ref_code"
                    label={"Код автошколы"}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.ref_code}
                  />
                  <CustomField
                    name="city"
                    label={"Город"}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.city}
                  />
                </div>
                <CustomField
                  margin={"normal"}
                  multiline
                  rows={3}
                  name="description"
                  label={"Коментарий"}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.description}
                />
              </div>
              <div className={Styles.user_redact_actions}>
                {/* <Button
                  variant="contained"
                  color="error"
                  onClick={handleDelete}
                  disabled={isSubmitting}>
                  Удалить автошколу
                </Button> */}
                <Button
                  disabled={isSubmitting || !Object.values(touched).length}
                  color="success"
                  variant="contained"
                  sx={{ marginLeft: "auto", justifySelf: "end" }}
                  onClick={handleSubmit}>
                  Сохранить
                </Button>
              </div>
            </>
          )}
        </Formik>
        <hr />
        <div className={Styles.user_field_area}>
          <h6>Данные директора</h6>
          <div
            className={Styles.user_fields}
            style={{ gridTemplateColumns: "1fr 1fr " }}>
            <CustomField
              disabled
              sx={{
                "& .MuiInputBase-input": { "-webkit-text-fill-color": "black" },
              }}
              value={state.director_name}
              label={"ФИО"}
            />
            <CustomField
              disabled
              sx={{
                "& .MuiInputBase-input": { "-webkit-text-fill-color": "black" },
              }}
              //   style={{ pointerEvenst: "none", userSelect: "none" }}
              label={"Телефон директора "}
              value={state.director_phone}
            />
          </div>
        </div>
        <hr />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "15px",
            height: "350px",
          }}>
          <h6>Заявки автошколы</h6>
          <div style={{ height: "250px" }}>
            <GridToolBar
              // onAdd={groupAddOpener}
              onUpdate={handleOrderRedactOpener}
              onRefresh={fetchOrderData}
              // onDelete={handleGroupDelete}
              dataToAction={orderRowData}
            />
            <AgGridReact
              onGridReady={onOrderGridReady}
              onRowClicked={orderRowClickHandler}
              gerRowId={getRowId}
              rowData={orderData}
              defaultColDef={defaultColDef}
              tooltipShowDelay={500}
              rowSelection={rowSelection}
              columnDefs={orderColumns}
              getRowStyle={getUserRowStyle}
            />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "15px",
            height: "350px",
          }}>
          <h6>Автомобили автошколы</h6>
          <div style={{ height: "250px" }}>
            <GridToolBar
              onAdd={autoAddOpener}
              onUpdate={handleAutoRedactOpener}
              onRefresh={fetchAutoData}
              onDelete={
                autoRowData && autoRowData.status === "deleted"
                  ? null
                  : handleAutoDelete
              }
              dataToAction={autoRowData}
            />
            <AgGridReact
              onGridReady={onAutoGridReady}
              onRowClicked={autoRowClickHandler}
              gerRowId={getRowId}
              rowData={autoData}
              defaultColDef={defaultColDef}
              tooltipShowDelay={500}
              rowSelection={rowSelection}
              columnDefs={autoColumns}
              getRowStyle={getUserRowStyle}
            />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "15px",
            height: "350px",
          }}>
          <h6>Сотрудники автошколы</h6>
          <div style={{ height: "250px" }}>
            <GridToolBar
              onAdd={handleAddWorkerOpener}
              onRefresh={fetchWorkerData}
              onUpdate={navToWorkerRedact}
              dataToAction={workerRowData}
            />
            <AgGridReact
              onGridReady={onWorkerGridReady}
              onRowClicked={workerRowClickHandler}
              gerRowId={getRowId}
              rowData={workerData}
              defaultColDef={defaultColDef}
              tooltipShowDelay={500}
              rowSelection={rowSelection}
              columnDefs={[
                ...userColumns,
                {
                  headerName: "Группы",
                  flex: 1,
                  filter: "agTextColumnFilter",
                  headerTooltip: "",
                  cellRenderer: (data) => {
                    const { id: userId } = data.data;
                    return (
                      groupData
                        .filter((group) => {
                          const { grouped_users } = group;

                          const currentUserData = grouped_users.find(
                            (user) => user.id == userId,
                          );

                          if (currentUserData) {
                            return group.name;
                          }
                        })
                        .map((group) => group.name)
                        .join(", ") || "Не прикреплен"
                    );
                  },
                },
              ]}
              getRowStyle={getUserRowStyle}
            />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "15px",
            height: "350px",
          }}>
          <h6>Группы автошколы</h6>
          <div style={{ height: "250px" }}>
            <GridToolBar
              onAdd={groupAddOpener}
              onUpdate={groupRedactOpener}
              onRefresh={fetchGroupData}
              onDelete={handleGroupDelete}
              dataToAction={groupRowData}
            />
            <AgGridReact
              onGridReady={onGroupGridReady}
              onRowClicked={groupRowClickHandler}
              gerRowId={getRowId}
              rowData={groupData}
              defaultColDef={defaultColDef}
              tooltipShowDelay={500}
              rowSelection={rowSelection}
              columnDefs={groupColumns}
              getRowStyle={getUserRowStyle}
            />
          </div>
        </div>

        <ReactCalendar practiceEnable={true} currentSchoolId={state.id} />
      </div>
    </section>
  );
}
